// @flow
import * as React from 'react';
// import Grid from 'styled-components-grid';

// import { FAQS_QUESTION } from '@routes';
// import { Link } from '@i18n';
import { ArrowIconClickToOpen } from '@images/svg/index';

import type { Props } from './types';

import {
  StyledLink,
  StyledTitleWrapper,
  StyledQuestion,
  StyledIconWrapper,
  StyledAnswer
} from './styles';

const Question = ({ questions }: Props): React.Node => {
  const [displayDescription, setDisplayDescription] = React.useState(null);


  return (
    <>
      { questions.map(question => (
        <StyledLink
          key={question.id}
        >
          <StyledTitleWrapper
            key={question.id}
            onClick={() => {
              setDisplayDescription(question.id === displayDescription ? false : question.id);
            }}
          >
            <StyledQuestion>
              {question.attributes.question}
            </StyledQuestion>
            <StyledIconWrapper active={question.id === displayDescription}>
              <ArrowIconClickToOpen />
            </StyledIconWrapper>
          </StyledTitleWrapper>
          <StyledAnswer active={question.id === displayDescription}>
            <div dangerouslySetInnerHTML={{ __html: question.attributes.answer }} />
          </StyledAnswer>
        </StyledLink>
      ))}
    </>
  );
};

export default Question;
